/**
 * Form view module
 *
 * @module views/base/form
 */
define('views/base/form',[
    'jquery',
    'views/base/view'
], function($, View) {
    'use strict';

    /**
     * Base form view class
     *
     * @class FormView
     * @constructor
     * @extends View
     */
    var FormView = View.extend({
        /**
         * @property autoRender
         * @type {boolean}
         */
        autoRender: true,
        /**
         * @property events
         * @type {object}
         */
        events: {
            'click [data-action=cancel]': 'dismiss',
            'click [data-action=submit]': 'submit',
            'submit': 'submit',
            'keyup input,textarea': 'changedAttribute',
            'keydown input,textarea': 'changedAttribute',
            'click input[type="checkbox"]': 'changedAttribute'
        },
        /**
         * @property tagName
         * @type {string}
         */
        tagName: 'form',
        /**
         * @property errorMessages
         * @type {array}
         */
        errorMessages: [],
        /**
         * @property loaderSelector
         * @type {string}
         */
        loaderSelector: '.loader',

        /**
         * Extend base data object
         *
         * @method getTemplateData
         * @return {object} with additional data
         */
        getTemplateData: function() {
            var object = View.prototype.getTemplateData.apply(this, arguments);

            object.errorMessages = this.errorMessages;

            return object;
        },

        /**
         * Adding additional action
         * clearing error messages
         *
         * @method render
         * @see View.render()
         */
        render: function() {
            View.prototype.render.apply(this, arguments);

            this.errorMessages = [];

            if (this.customValidation) {
                this.setupValidation();
            }
        },

        setupValidation: function() {

            var inputs = this.$el.find('input');

            inputs.on('invalid', function(e) {
                e.preventDefault();

                var classes = ['invalid'];
                for (var key in this.validity) {
                    if (this.validity[key] === true) {
                        classes.push('invalid-' + key);
                    }
                }
                $(this).parents('.validate').addClass(classes.join(' '));

            });

            $(inputs).change(function() {
                $(this).parents('.validate').removeClass(function (index, css) {
                    return (css.match(/(^|\s)invalid(\S+)?/g) || []).join(' ');
                });
            });
        },

        /**
         * Publishing save if not exists throw error
         *
         * @method publishSave
         * @param {object} response on save
         */
        publishSave: function(response) {
            if (this.saveEvent) {
                this.publishEvent(this.saveEvent, response);
            } else {
                throw new Error('FormView must have saveEvent defined');
            }
        },

        /**
         * Reset form fields
         *
         * @method dismiss
         * @param {Event} event
         */
        dismiss: function(event) {
            if (event) {
                event.preventDefault();
            }
            this.trigger('dispose');
            this.dispose();
        },

        /**
         * @method save
         */
        save: function() {
        },

        /**
         * Submit form event
         *
         * @method submit
         * @param {Event} event
         */
        submit: function(event) {
            if (event) {
                event.preventDefault();
            }

            $('input', this.$el).not('[aria-hidden]').not('.select2-search__field').trigger('keyup');

            if (this.$el[0].checkValidity()) {
                this.showLoader();
                this.disableActions();
                this.save(event);
            }
        },

        /**
         * Sync attribute with model
         *
         * @method changedAttribute
         * @param {Event} event
         */
        changedAttribute: function(event) {
            var setObject = {};

            if(!this.model.get('skipValidity')) {
                if (!event.currentTarget.validity.valid) {
                    return;
                }
            }

            if (event.metaKey && event.keyCode === 13) {
                this.$el.trigger('submit');
            } else {
                var $target = $(event.currentTarget);

                setObject[$target.attr('name')] = $target.is(':checkbox') ? $target.is(':checked') : $target.val();

                this.model.set(setObject);
            }
        },
        /**
         * Disable form
         *
         * @method disableActions
         */
        disableActions: function() {
            $('input, button, textarea, select', this.$el).prop('disabled', true);
        },
        /**
         * Show loader
         *
         * @method showLoader
         */
        showLoader: function() {
            (this.loaderSelector ? $(this.loaderSelector, this.$el) : this.$el).addClass('preloader');
        },

        /**
         * Hide loader
         *
         * @method hideLoader
         */
        hideLoader: function() {
            $(this.loaderSelector ? $(this.loaderSelector, this.$el) : this.$el).removeClass('preloader');
        }

    });

    return FormView;
});

